



























































import {
  ProductWarehouseItem,
  WarehouseItemCustomization,
  ProductCustomization,
  PrintAreaCustomization,
  Product,
} from "@/models";
import { Vue, Component } from "vue-property-decorator";
import ListItem from "@/components/Customizer/Customization/Item.vue";
import { customizationStore, httpStore } from "@/store/typed";
import { isMobile } from "@/helpers/mediaQueryHelper";
import DotLoader from "@/components/Common/DotLoader.vue";
import {PrintAreaCustomizationMixinTags} from "@/mixins/http/PrintAreaCustomizationMixin"
import { createPopper } from "@popperjs/core";

@Component({
  components: {
    ListItem,
    DotLoader
  },
})
export default class CustomizationList extends Vue {

  addingToCart = false;
  private popperInstance = null;

  get isMobile(): boolean {
    return isMobile((this as any).$mq);
  }

  get product(): Product {
    return customizationStore.product;
  }

  get editMode(): boolean {
    return customizationStore.editMode;
  }

  get productCustomization(): ProductCustomization {
    return customizationStore.productCustomization;
  }

  get updateable():boolean{
    return customizationStore.updateable;
  }

  goToCart(): void {
    if(!this.allSidesConfigured){
      this.showItemNotCompletedTooltip();
      return;
    }
    this.addingToCart = true;
    this.$emit("goToCart");
  }

  addToCart(): void {
    if(!this.allSidesConfigured){
      this.showItemNotCompletedTooltip();
      return;
    }
    this.addingToCart = true;
    this.$emit("addToCart");
  }

  get printAreaCustomizationIndex(): number {
    return this.printAreaCustomizations.findIndex(
      (o: PrintAreaCustomization) =>
        o.id === customizationStore.currentPrintAreaCustomization?.id
    );
  }

  get printAreaCustomizations() {
    return customizationStore.printAreaCustomizations;
  }

  loadNextItem() {
    customizationStore.setMode("2d");
    if (customizationStore.navigationLocked) {
      return;
    }

    const item =
      this.printAreaCustomizations[this.printAreaCustomizationIndex + 1];
    const warehouseItemCustomization =  customizationStore.warehouseItemCustomizations.find((wic: WarehouseItemCustomization) => wic.id == item.warehouseItemCustomizationId );
    customizationStore.setWarehouseItemCustomization(
      warehouseItemCustomization
    );
    customizationStore.setPrintAreaCustomization(item);
  }

  get showAddToCartButton() {
    return (
      this.printAreaCustomizationIndex ===
      customizationStore.printAreaCustomizations.length - 1
    );
  }

  get warehouseItemCustomizations(): WarehouseItemCustomization[] {
    return customizationStore.warehouseItemCustomizations;
  }

  get warehouseItemCustomizationsGroupedByWarehouseItem(): any {
    return this.warehouseItemCustomizations.reduce((acc: any, curr) => {
      if (!acc[curr.warehouseItem.id]) {
        acc[curr.warehouseItem.id] = [];
      }
      acc[curr.warehouseItem.id].push(curr);
      return acc;
    }, {});
  }

  get productWarehouseItems(): ProductWarehouseItem[] {
    return this.product?.productWarehouseItems;
  }

  get allSidesConfigured(): boolean {
    return customizationStore.allItemsConfigured;
  }

  get loading(): boolean{
    return httpStore.status[PrintAreaCustomizationMixinTags.UploadAsync]?.loading;
  }

   showItemNotCompletedTooltip() {
    const popcorn = document.getElementById("to-cart");
    const tooltip = document.getElementById("tooltip");
    if (!this.popperInstance) {
      this.popperInstance = createPopper(popcorn, tooltip, {
        placement: "top-start",
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, 10],
            },
          },
        ],
      });
    }
    tooltip.setAttribute("data-show", "");
  }

  hideItemNotCompletedTooltip() {
    const tooltip = document.getElementById("tooltip");
    tooltip?.removeAttribute("data-show");
  }
}
